<script>

import { useToast } from "vue-toastification";
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

import UserCircle from '@/ui/UserCircle'

import ProjectEdit from '@/components/CustomWorking/WorkingProjects/ProjectEdit.vue'
import ProjectDelete from '@/components/CustomWorking/WorkingProjects/ProjectDelete.vue'
import ProjectPhotos from '@/components/CustomWorking/WorkingProjects/ProjectPhotos.vue'

import CheckboxToggle from '@/components/General/CheckboxToggle'
import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

//data
import { getProjects, changeStateProject } from '@/services/working/serviceProject';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Projects',
	mixins: [ MixinGeneralFunct ],
	components: {
		ProjectEdit,ProjectDelete,ProjectPhotos
		,UserCircle
		,MyPagination,MyCountRecords
		,LoadingScreen
		,Alert
		,CheckboxToggle
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
            metaData:[],
            
            isLoading:true,

            helpboxData: [],
            
            totalCount:0,
            dataList:[],
            selectedFilterText:'',
            
            selectedType:'',

            selectedProjectId:'',

			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
			
			checkAllItems:false,

			showFilter:false,
			filterExtended:true,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',
			
			modalEdit:{},
			modalEditId:'',
			
			modalPhotos:{},
			modalPhotosId:'',
		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;
		this.modalPhotosId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
				
		onLoadPage:function(){
		
			this.isLoading=true
			
			getProjects({filterText: this.selectedFilterText, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;
					
					//oznacenie poloziek cez strankovac
					for(let i = 0; i < this.dataList.length; i++){
						if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
							this.dataList[i].selectedId=true;
						}
					}
					
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});
		
		},
		
				
				
		
		
		
		//(od)oznacenie vsetkych poloziek
		onCheckAllItems:function(){
			if(this.checkAllItems){
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=true;
					if(this.allSelectedItems.indexOf(this.dataList[i].id)==-1){
						this.selectedItemStore.addSelectedItems(this.dataList[i].id);
					}
				}
			}else{
				for(let i = 0; i < this.dataList.length; i++){
					this.dataList[i].selectedId=false;
					var indexToRemove = this.allSelectedItems.indexOf(this.dataList[i].id);
					if(indexToRemove>=0){
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
		},
		
		//oznacenie jednej polozky
		onCheckItem:function(index,id){
			if(this.dataList[index].selectedId==true){
				this.selectedItemStore.addSelectedItems(id);
			}else{
				var indexToRemove = this.allSelectedItems.indexOf(id);
				this.selectedItemStore.deleteSelectedItems(indexToRemove);
			}
		},

		//zrusenie vyberu
		onResetSelected:function(){
			for(let i = this.allSelectedItems.length; i>=0 ;i--){
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if(indexToRemove>=0){
					var index = this.dataList.findIndex(item => item.id==this.allSelectedItems[i]); 
					if(index>=0){
						this.dataList[index].selectedId=false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		

		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box  editacia
		loadModalFormProjectEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedProjectId=String(recordID);
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box  delete
		loadModalFormProjectDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedProjectId=String(recordID);
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},

		//modal box  preview photos
		loadModalFormProjectPhotosPreview:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedProjectId=String(recordID);
			this.modalPhotos = new bootstrap.Modal(document.getElementById(this.modalPhotosId), {backdrop:'static'})
			this.modalPhotos.show();
		},
		
		

		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedProjectId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},

		//zmena stavu
		onChangeState:function(e){
			this.cSession();			
			this.isLoading=true
			changeStateProject({projectId:e.id,state:e.state}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},
		
		
		
	},	
	
			
	watch: {
		'auth.projectsList': function () {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>

		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
		<div id="version" class="version"><p>{{metaData.version}}</p></div>

		<div v-if="metaData.modulAccess" > 
					
            <div class="row">
                <div class="col-12">
                                    
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCustomWorking.Projects') }}</h5>	 
						</div> 
						
						<div class="col-6 right">
							<button type="button" :disabled="!auth.projectsNew" v-on:click="loadModalFormProjectEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
						</div> 
					</div>

					<!-- filters basic -->
					<div class="row">
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i> 
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
					</div>
					

					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-4">
					
														
						</div>					
					</div>
                        
                    
                </div>
            </div>	

            
            <!-- zakladny zoznam -->
            <div v-if="totalCount>0">

				<div class="row">
					<div class="col-12">
	
						<div class="table-responsive">
							<table class="table table-hover table-sm">
							
								<thead>
									<tr>
										<th class="orderBy" v-on:click="sort('id')" :class="{ active: isActive('id'), asc: isAsc('id'), desc: isDesc('id')}">id</th>

										<th width="10" class="align-middle">
												<div class="form-check">
													<label class="form-check-label">
													<input v-model="checkAllItems" v-on:change="onCheckAllItems()" class="form-check-input" type="checkbox">
													<span class="form-check-sign">
														<span class="check"></span>
													</span>
													</label>
												</div>
											</th>
										

										<th>{{$t('msgCore.Action')}}</th>

										<th colspan="2">{{$t('msgCore.State')}}</th>

										<th>Náhľad</th>
										
										<th v-if="auth.tasksItemNew"><span class="green">{{$t('msgCustomWorking.paid')}}</span>/<span class="red">{{$t('msgCustomWorking.gratis')}}</span></th>
										
										<th>{{$t('msgCore.Title')}}</th>
										
										<th>{{$t('msgCore.Description')}}</th>
										
										<th>{{$t('msgCore.Url')}}</th>
										
										<th>{{$t('msgCustomWorking.UrlAdmin')}}</th>
										
										<th>{{$t('msgCustomWorking.Hosting')}}</th>
										
										<th>{{$t('msgCustomWorking.Platform')}}</th>
										
										<th>{{$t('msgCore.Created')}}</th>
                                            
                                        <th>{{$t('msgCore.Modified')}}</th>							
									</tr>
								</thead>
								
								
								<tr v-for="(basicObj, index) in dataList" :key="basicObj" >
								
									<td>{{ basicObj.id }}</td>

									<td class="align-middle">
											<div class="form-check">
												<label class="form-check-label">
												<input v-model.number='basicObj.selectedId' class="form-check-input" type="checkbox" v-on:change="onCheckItem(index,basicObj.id);">
												<span class="form-check-sign"><span class="check"></span></span>
												</label>
											</div>	
										</td>
								
									<td class="align-middle">
										<div class="input-group">	
											
												<button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.campaignsUnlock" v-on:click="unlockCampaign(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>	
																				
											<div class="btn-group">				
												<button type="button" :disabled="!auth.projectsEdit && !secData.isSA" v-on:click="loadModalFormProjectEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn" class="btn btn-secondary btn-sm"><i class="smire-icon fas fa-edit"></i></button>
										
												<button type="button" :disabled="!auth.projectsDelete && !secData.isSA" v-on:click="loadModalFormProjectDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" id="myModalBtn" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-trash-alt"></i></button>
											</div>	
											
											<div class="btn-group">
												<button type="button" :disabled="!auth.projectPhotoView" v-on:click="loadModalFormProjectPhotosPreview(basicObj.id)" :title="$t('msgCore.btnPreview')" class="btn btn-info btn-sm"><i class="smire-icon fas fa-images"></i>
												<span class="btn-number-top-right">{{ basicObj.countPhotos }}</span>
												</button>
											</div>
											
										</div>	
									</td>

									<td  :title="$t('msgCore.' + basicObj.state_name)">
										<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2}" ></i>
									</td>

									<td>
										<CheckboxToggle v-if="basicObj.state!=3" :key="basicObj.id" :isDisabled="(!auth.projectsChangeState)" :data="basicObj" @onClick="onChangeState"></CheckboxToggle>
									</td>
									
									<td>
										<a v-if="basicObj.photoDataPreview" class="fancybox" data-fancybox="gallery" :href="basicObj.photoData"><img :src="basicObj.photoDataPreview" style="height:80px;"></a>
										
									</td>
									
									<td v-if="auth.tasksItemNew" class="align-middle">
								
										
										<span v-for="(priceItem) in basicObj.priceData" :key="priceItem" >
											<span :class="priceItem.color">{{ priceItem.paid }}</span> /
											<span :class="priceItem.color">{{ priceItem.free }}</span>
										<br></span>
										
									</td>									
									
									<td >{{ basicObj.title }}</td>
									
									<td >{{ basicObj.description }}</td>
									
									<td >
										<a :href="basicObj.url" target="_blank">{{ basicObj.url }}</a>
									</td>
									
									<td >
										<a :href="basicObj.url_admin" target="_blank">{{ basicObj.url_admin }}</a>
									</td>
									
									<td >{{ basicObj.hosting }}</td>
									
									<td >{{ basicObj.platform }}</td>

									<td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
								</tr>
									

							
							</table>	
						</div>		
					
					</div>
				</div>

				<div class="row row-pagination">
					<div class="col-6 col-md-3 col-lg-2">
						<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
					</div>
					
					<div class="col-6 col-md-3 col-lg-2 box-flex">
						<span>Počet: {{totalCount}} <button v-if="allSelectedItems.length>0" type="button" @click="onResetSelected()" class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i class="fas fa-times"></i></button></span>
					</div>
					
					<div class="col-12 col-md-6 col-lg-8">	
						<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
					</div>
				</div>
                    
                
            </div>	
            
            <div v-else class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>							
            </div>
            
        </div>	
        
        <div v-else class="container-fluid">
            <div class="row">
				<div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
            </div>
        </div>
	
		<ProjectEdit :auth="auth" :secData="secData" :projectId="selectedProjectId" @changeRecord="onChangeItem" :modalObject="modalEdit" :modalId="modalEditId"></ProjectEdit>
		<ProjectDelete :auth="auth" :secData="secData" :projectId="selectedProjectId" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></ProjectDelete>
		<ProjectPhotos :auth="auth" :secData="secData" :projectId="selectedProjectId" @changeRecord="onChangeItem" :modalObject="modalPhotos" :modalId="modalPhotosId" ></ProjectPhotos>
	</div>	
		
</template>


